import React, { useEffect } from 'react'
import { Views } from '../../views'
import { has } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { refererRegister, routersHelper } from '../../helpers'

const Referer = () => {
    const { Referer } = Views
    const dispatch = useDispatch()
    const { useRouter } = routersHelper
    const router = useRouter()
    const keycloak = useSelector(state => state.keycloak)
    const language = useSelector(state => state.language)

    useEffect(() => {
        if (has(router, 'query.referrer')) {
            refererRegister(keycloak, language, router.query.referrer)
        }
        

    }, [dispatch, keycloak, language,router])
   
    if (has(router,'query.referrer')) {
        return <Referer />
    } else {
        window.location.href =  `/portal/error?errorCode=404&message=error_text_1&setLog=true`
    }
    
}

export default Referer